import { render, staticRenderFns } from "./outStockDtl.vue?vue&type=template&id=01a276bc&scoped=true&"
import script from "./outStockDtl.vue?vue&type=script&lang=js&"
export * from "./outStockDtl.vue?vue&type=script&lang=js&"
import style0 from "./outStockDtl.vue?vue&type=style&index=0&id=01a276bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a276bc",
  null
  
)

export default component.exports